const baseTheme = {
  fonts: {
    mono: '"SF Mono", "Roboto Mono", Menlo, monospace',
  },
};

// Zero Two Light
const lightTheme = {
  ...baseTheme,
  colors: {
    "infoForeground": "#5282a2",
    background: '#fffff00',
    "baseBackground": "#fcfcfc",
    "headerColor": "#f5f5f5",
    "secondaryBackground": "#fcfcfc",
    heading: '#000',
    text: '#252427',
    preFormattedText: 'rgb(245, 247, 249)',
    link: '#a61d0d',
    "selectionBackground": "#e9b4b8",
    "selectionForeground": "#393d45",
    "accentColor": "#a61d0d",
    "borderColor": "#eeeeee",
    "caretRow": "#f6f6f6",
    "comments": "#6a737d",
    "accentColorTransparent": "#a61d0d5A",
    "baseIconColor": "#85838b",
    "buttonColor": "#f0f0f0",
    "buttonFont": "#252427",
    "foregroundColor": "#252427",
  },
};

// Jahy Dark
const darkTheme = {
  ...baseTheme,
  colors: {
    "infoForeground": "#ad9e6e",
    background: '#00193300',
    baseBackground: '#221738',
    headerColor: '#1e1430',
    "secondaryBackground": "#220e29",
    heading: '#fff',
    text: '#cbcbcb',
    preFormattedText: '#000',
    link: '#874488',
    "selectionBackground": "#220e29",
    "selectionForeground": "#fbfbfb",
    "accentColor": "#874488",
    "borderColor": "#322252",
    "caretRow": "#2f1336",
    "comments": "#816F93",
    "accentColorTransparent": "#8744885A",
    "baseIconColor": "#6c677a",
    "buttonColor": "#352544",
    "buttonFont": "#ada19c",
    "foregroundColor": "#F8F8F2"
  },
};

export { lightTheme, darkTheme };
